// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file inventory/inventory_branch_split.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { InventoryBranchSplitItem, ItemType } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.InventoryBranchSplitRequest
 */
export class InventoryBranchSplitRequest extends Message<InventoryBranchSplitRequest> {
  /**
   * Filter by batch ID to get the inventory ledger for a specific batch
   *
   * @generated from field: string master_id = 1;
   */
  masterId = "";

  /**
   * Type of the item (e.g., MEDICAL, NON_MEDICAL)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 2;
   */
  itemType = ItemType.UNSPECIFIED;

  constructor(data?: PartialMessage<InventoryBranchSplitRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.InventoryBranchSplitRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InventoryBranchSplitRequest {
    return new InventoryBranchSplitRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InventoryBranchSplitRequest {
    return new InventoryBranchSplitRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InventoryBranchSplitRequest {
    return new InventoryBranchSplitRequest().fromJsonString(jsonString, options);
  }

  static equals(a: InventoryBranchSplitRequest | PlainMessage<InventoryBranchSplitRequest> | undefined, b: InventoryBranchSplitRequest | PlainMessage<InventoryBranchSplitRequest> | undefined): boolean {
    return proto3.util.equals(InventoryBranchSplitRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.InventoryBranchSplitResponse
 */
export class InventoryBranchSplitResponse extends Message<InventoryBranchSplitResponse> {
  /**
   * List of inventory branch split items for the specified batch
   *
   * @generated from field: repeated com.neulink.pharmacy.InventoryBranchSplitItem inventory_branch_split_items = 1;
   */
  inventoryBranchSplitItems: InventoryBranchSplitItem[] = [];

  /**
   * Total number of inventory ledger items for the specified batch
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<InventoryBranchSplitResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.InventoryBranchSplitResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "inventory_branch_split_items", kind: "message", T: InventoryBranchSplitItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InventoryBranchSplitResponse {
    return new InventoryBranchSplitResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InventoryBranchSplitResponse {
    return new InventoryBranchSplitResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InventoryBranchSplitResponse {
    return new InventoryBranchSplitResponse().fromJsonString(jsonString, options);
  }

  static equals(a: InventoryBranchSplitResponse | PlainMessage<InventoryBranchSplitResponse> | undefined, b: InventoryBranchSplitResponse | PlainMessage<InventoryBranchSplitResponse> | undefined): boolean {
    return proto3.util.equals(InventoryBranchSplitResponse, a, b);
  }
}

